import { z } from 'zod';

export const UserCallOffer = z.object({
  /// A unique identifier for this offer to differentiate it for tracking
  id: z.string(),
  scope: z.string(),
  context: z.string(),
  freePoints: z.number().optional(),
  freeMonths: z.number().optional(),
  /// A map of localizable string slugs OR replacement strings
  strings: z
    .object({
      /// Appears as the main title of the modal
      title: z.string(),
      /// A lower impact descriptive paragraph below the title
      description: z.string(),
      /// The label of the main opt-in button
      callToActionButtonLabel: z.string(),
      /// The label of the cancel button
      cancelButtonLabel: z.string(),
    })
    .partial()
    .default({}),
  /// A map of asset urls to replace the defaults if necessary
  assetURLs: z
    .object({
      topImage: z.string(),
    })
    .partial()
    .default({}),
  /// A localizable string slug containing a locale-specific URL or a replacement URL
  calendlyLink: z.string(),
});
export type UserCallOffer = z.infer<typeof UserCallOffer>;
